'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('admin-home', {
      url: '/home/admin',
      template: '<admin-home></admin-home>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin-home/admin-home.routes.js